import {
  getIndicatorSupportMceSummaryByEa,
  getIndicatorSupportMceSummaryByRegionalDelegation,
} from "../../../../../../rest/indicator";
import { makeWorkbook } from "../../utils/excel";

const fmtInt = (n) => (typeof n === "number" ? n : Number(n || 0));

const rowsFrom = (payload) =>
  Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload?.results)
    ? payload.results
    : Array.isArray(payload)
    ? payload
    : [];

async function fetchMceData() {
  const [eaRes, regRes] = await Promise.all([
    getIndicatorSupportMceSummaryByEa(),
    getIndicatorSupportMceSummaryByRegionalDelegation(),
  ]);

  const eaPayload = eaRes?.data || {};
  const regPayload = regRes?.data || {};

  const eaList = rowsFrom(eaPayload).map((r) => ({
    eaId: r?.eaUserId ?? r?.eaId ?? r?.id ?? null,
    eaName: r?.eaName ?? r?.description ?? r?.name ?? "-",
    mceContracted: Number(r?.mceContracted ?? 0),
    mcePaidCount: Number(r?.mcePaidCount ?? 0),
    mcePaidValue: Number(r?.mcePaidValue ?? 0),
  }));

  const regList = rowsFrom(regPayload).map((r) => ({
    regionalDelegationId: r?.regionalDelegationId ?? r?.id ?? null,
    regionalDelegationName: r?.regionalDelegationName ?? r?.name ?? "-",
    mceContracted: Number(r?.mceContracted ?? 0),
    mcePaidCount: Number(r?.mcePaidCount ?? 0),
    mcePaidValue: Number(r?.mcePaidValue ?? 0),
    eaCount: Number(r?.eaCount ?? 0),
  }));

  return { eaList, regList };
}

export async function buildWorkbookMCESupport() {
  const { eaList, regList } = await fetchMceData();

  const eaKpi = eaList.reduce(
    (acc, r) => {
      acc.contrat += Number(r.mceContracted || 0);
      acc.pagos += Number(r.mcePaidCount || 0);
      acc.valor += Number(r.mcePaidValue || 0);
      return acc;
    },
    { contrat: 0, pagos: 0, valor: 0 }
  );

  const resumo = [
    ["Indicador", "Valor"],
    ["MCE - Contratualizado (EA)", fmtInt(eaKpi.contrat)],
    ["MCE - N.º Relatórios Pagos (EA)", fmtInt(eaKpi.pagos)],
    ["MCE - Relatórios Pagos (EA)", Number(eaKpi.valor)],
  ];

  const eaMce = [
    ["EA", "MCE Contratualizado", "N.º Relatórios Pagos", "Relatórios Pagos"],
    ...eaList.map((r) => [
      r.eaName ?? "",
      fmtInt(r.mceContracted),
      fmtInt(r.mcePaidCount),
      Number(r.mcePaidValue || 0),
    ]),
  ];

  const drMce = [
    ["Delegação", "MCE Contratualizado", "N.º Relatórios Pagos", "Relatórios Pagos", "N.º de EAs"],
    ...regList.map((r) => [
      r.regionalDelegationName ?? "",
      fmtInt(r.mceContracted),
      fmtInt(r.mcePaidCount),
      Number(r.mcePaidValue || 0),
      fmtInt(r.eaCount),
    ]),
  ];

  return makeWorkbook([
    { name: "Resumo", aoa: resumo },
    { name: "EA_MCE", aoa: eaMce },
    { name: "Delegacoes_MCE", aoa: drMce },
  ]);
}
